import axios from "axios";
import callAPI from "config/callAPI";
import { getDeviceDetails } from "libraries/common_functions";

import React from "react";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/track_url_and_redirect';

class Redirect extends React.Component {

    constructor(){
        super();
        this.state = {
            rmessage: 'Please wait while you are being redirected!',
            alertColor: ''
        }

        this.trackURLAndRedirect();
    }

    async getIPLocation() {
        const res = await axios.get("https://ipapi.co/json/"); 
        var ip =  res.data.ip; 
        var location = res.data.city + ', ' + res.data.country_name;
        return {ip, location};
    };

    async trackURLAndRedirect(){
        var {ip, location} = await this.getIPLocation(); 
        let url = window.location.pathname;
        var shortened_slug = url.split('/')[1]; 

        let recievedDeviceDetails = await getDeviceDetails(); 
        var device_type = recievedDeviceDetails.device_type;
        var device_name = recievedDeviceDetails.device_name;
        var device = recievedDeviceDetails.device;
        if (shortened_slug !== null && shortened_slug !== undefined && parseInt(shortened_slug, 16) > 0 && ip !== '' && location !== '' && device_type !== undefined && device_name !== undefined && device !== undefined){ 
            var data = {shortened_slug: shortened_slug, ip_address: ip, location: location, device_type: device_type, device_name: device_name, device: device};
            // eslint-disable-next-line
            const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data);
            this.setState({
                rmessage: rmessage,
                alertColor: 'red'
            });

            if (rstatus){
                this.setState({
                    alertColor: 'green'
                });

                var destination_url = rdata.destination_url;
                window.location = destination_url;
                return true;
            } else {
                window.location = '/';
                return false;
            }
        } else {
            window.location = '/';
            return false;
        }
    }

    render() {
        return (
            <>
                <p style={{"color": this.state.alertColor}}><b>{this.state.rmessage}</b></p>
            </>
        );
    }
}

export default Redirect;
